import React from 'react';

// Étoile à 5 branches calculée directement (pas de tracé FontAwesome recopié,
// cf. ShapesStarIcon) : plus simple à empiler proprement avec le carré que de
// retoucher des tracés/transforms taillés pour un tout autre agencement (3
// formes en triangle, pas 2 en colonne).
const starPoints = (cx, cy, outerRadius, innerRadius) => {
  const points = [];
  for (let i = 0; i < 10; i += 1) {
    const radius = i % 2 === 0 ? outerRadius : innerRadius;
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    points.push(`${cx + radius * Math.cos(angle)},${cy + radius * Math.sin(angle)}`);
  }
  return points.join(' ');
};

// Variante de ShapesStarIcon réduite à l'étoile et au carré, empilés
// verticalement — utilisée par ShapesStarEditIcon, qui ajoute un crayon en
// couche à droite : un ShapesStarIcon complet (3 formes) n'y aurait pas
// laissé assez de place pour un badge lisible.
// Rendu duotone même principe que DuotoneLightIcon (une seule couleur, deux
// tons) : le tracé (stroke) porte la couleur pleine — la couche "primaire" —
// et le remplissage (fill) la même couleur atténuée à `secondaryOpacity` — la
// couche "secondaire" — pour rester cohérent avec les icônes FontAwesome
// Duotone utilisées à côté (même défaut 0.4 que DuotoneLightIcon).
const ShapesStarSquareIcon = ({ style = {}, secondaryOpacity = 0.4 }) => {
  const { color = 'currentColor', ...rest } = style;

  return (
    <svg
      viewBox='0 0 75 100'
      width='0.75em'
      height='1em'
      fill={color}
      fillOpacity={secondaryOpacity}
      stroke={color}
      strokeWidth={5}
      strokeLinejoin='round'
      style={rest}
      aria-hidden='true'
      focusable='false'
    >
      <polygon points={starPoints(37.5, 27, 24, 13.5)} />
      <rect x='11' y='55' width='53' height='42' rx='9' />
    </svg>
  );
};

export default ShapesStarSquareIcon;
